import React, { useState } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

const HelicopterForm = () => {
  const [formData, setFormData] = useState({
    brokerId: "",
    brokerageStatus: "",
    enginePower: "",
    manufacturer: "",
    model: "",
    yearOfManufacturing: "",
    generalDescription: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    price: "",
    listingControl: "",
    signedForListingAgreement: "",
    status: "",
    listingStartDate: "",
    listingEndDate: "",
    images: [],
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      setFormData({ ...formData, images: [...files] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", formData);
    // handle API call here
  };

  return (
    <Container className="my-5 p-4 bg-light rounded shadow-sm">
      <h2 className="mb-4 text-center">Helicopter Listing Form</h2>
      <Form onSubmit={handleSubmit}>
        {/* 🛠️ General Info */}
        <h4 className="mt-4 mb-3">General Information</h4>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Broker ID</Form.Label>
              <Form.Control
                type="text"
                name="brokerId"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Brokerage Status</Form.Label>
              <Form.Select name="brokerageStatus" onChange={handleChange}>
                <option>Select...</option>
                <option value="Available for Co-Brokerage">
                  Available for Co-Brokerage
                </option>
                <option value="Not Available for Co-Brokerage">
                  Not Available for Co-Brokerage
                </option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Engine Power</Form.Label>
              <Form.Control
                type="text"
                name="enginePower"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Manufacturer</Form.Label>
              <Form.Control
                type="text"
                name="manufacturer"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Model</Form.Label>
              <Form.Control type="text" name="model" onChange={handleChange} />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Year of Manufacturing</Form.Label>
              <Form.Control
                type="number"
                name="yearOfManufacturing"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>General Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="generalDescription"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* 🌍 Location Info */}
        <h4 className="mt-5 mb-3">Location</h4>
        <Row>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control type="text" name="city" onChange={handleChange} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control type="text" name="state" onChange={handleChange} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                name="country"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Zipcode</Form.Label>
              <Form.Control
                type="text"
                name="zipcode"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* 💰 Listing Details */}
        <h4 className="mt-5 mb-3">Listing Details</h4>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                name="price"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Listing Control</Form.Label>
              <Form.Select name="listingControl" onChange={handleChange}>
                <option>Select...</option>
                <option value="Display">Display</option>
                <option value="Not Display">Not Display</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Signed for Listing Agreement</Form.Label>
              <Form.Select
                name="signedForListingAgreement"
                onChange={handleChange}
              >
                <option>Select...</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* 🚦 Listing Status */}
        <h4 className="mt-5 mb-3">Status & Dates</h4>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select name="status" onChange={handleChange}>
                <option>Select...</option>
                <option value="Charter">Charter</option>
                <option value="Sold">Sold</option>
                <option value="Draft">Draft</option>
                <option value="Private">Private</option>
                <option value="Suspended">Suspended</option>
                <option value="Under Contract">Under Contract</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Listing Start Date</Form.Label>
              <Form.Control
                type="date"
                name="listingStartDate"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Listing End Date</Form.Label>
              <Form.Control
                type="date"
                name="listingEndDate"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* 🖼️ Media Upload */}
        <h4 className="mt-5 mb-3">Media</h4>
        <Form.Group className="mb-4">
          <Form.Label>Upload Images</Form.Label>
          <Form.Control
            type="file"
            name="images"
            multiple
            onChange={handleChange}
          />
        </Form.Group>

        <div className="text-center">
          <Button variant="primary" type="submit" size="lg">
            Submit Listing
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default HelicopterForm;
